import { render, staticRenderFns } from "./FlightBrands.vue?vue&type=template&id=122509d0&scoped=true"
import script from "./FlightBrands.vue?vue&type=script&lang=js"
export * from "./FlightBrands.vue?vue&type=script&lang=js"
import style0 from "./FlightBrands.vue?vue&type=style&index=0&id=122509d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122509d0",
  null
  
)

export default component.exports